<template lang="pug">
modal#delete-developer-client-modal(
  :noFooter='true'
  :title='$t("modal.paymentInProgress.title")'
  @process='closeModal'
  ref='modal'
)
  .text-center
    img.mt-4.mb-3(
      alt='developer-delete-warning'
      src='/img/ilustrations/subscription-reminder.svg'
    )
    p.text-start {{ $t('modal.paymentInProgress.message') }}

  .modal-footer.p-0.d-flex.justify-content-end
    button#buttonColor.btn.btn-primary(@click='closeModal' type='button')
      | {{ $t('modal.paymentInProgress.closeButtonLabel') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'CreatingAppInfoModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
